import '../css/main.css';
export function Footer() {
    return (
        <div className="App">
            <footer className="App-footer">
                Powered by GoDaddy. All Rights Reserved.
            </footer>
        </div>
    );
}